import axios, { getStandardAxiosConfig } from '../../util/api';

class IntegrationsAPI {
  static syncBCMS (org) {
    return axios.post(
      `/orgs/integrations/bcms/${org.id}`,
      { ...org },
      getStandardAxiosConfig()
    );
  }
  static syncAgriwebb (org) {
    return axios.post(
      `/orgs/integrations/agriwebb/${org.id}`,
      { ...org },
      getStandardAxiosConfig()
    );
  }
}

export default IntegrationsAPI;
